export default __webpack_public_path__ + "static/media/NO_DOMAIN_SEARCH_RESULT_ICON.8ee3ffb4.svg";